/* eslint-disable react/prop-types */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import {
  Grid,
  Typography,
  Button,
  CardContent,
  Card,
  CircularProgress,
  TextField,
  IconButton,
} from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from "@mui/material/Divider";
import { useDropzone } from "react-dropzone";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ControlledExpansionPanels from "../../../../components/ControlledExpansionPanels/ControlledExpansionPanels";
import PayViaBankTransferTableComponentsForm from "./PayViaBankTransferTableComponentsForm";

const styles = () => ({
  root: {
    flexGrow: 1,
    margin: 10,
  },
  blockStyle: {
    paddingLeft: 10,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: "left",
    border: "1px solid rgb(211, 211, 211)",
    borderRadius: 5,
  },
});

const useStyles = makeStyles(styles);

function MyDropzone(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map((file, index) => {
    const size = file.size > 0 ? (file.size / 1000).toFixed(2) : file.size;
    return (
      <Typography key={index} variant="subtitle1" color="primary">
        {file.path} - {size} Kb
        <input type="hidden" name="file_name" value={file.path}></input>
      </Typography>
    )
  });
  let msg = files;
  if (props.form.files.length <= 0 || files.length <= 0) {
    msg = <Typography variant="subtitle1">
      Please click to select a file or drop your file here
    </Typography>;
  }
  return (
    <div
      style={{ textAlign: "center" }}
      {...getRootProps({ className: "dropzone", onChange: event => props.onChange(event) })}
    >
      <Card style={{ backgroundColor: "#c7c7c7" }}>
        <CardContent style={{
          paddingBottom: 18
        }}>
          <input
            name="contained-button-file"
            {...getInputProps()}
            disabled={props.disabled}
          />
          {msg}
        </CardContent>
      </Card>
    </div>
  );
}

const PayThroughBankTransfer = (props) => {
  const classes = useStyles();
  const {
    values = {},
    handleSubmitButtonClick = fn => fn,
    handleChange = fn => fn,
    handleSubmit = fn => fn,
    handleFileChange = fn => fn,
    handleDateChange = fn => fn,
    type = 0,
    onRefCheckChnage = fn => fn,
    handleClose = fn => fn,
    downloadFile = fn => fn,
    deleteFile = fn => fn,
  } = props;
  const { form, formErrors } = values;

  return (
    <Fragment>
      <div className={classes.root}>
        <div
          style={{
            marginBottom: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "96%" }}>
            <form
              id="myform"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              {type === 0 ?
                <input type="hidden" name="documentTypeId" value={7} />
                : <input type="hidden" name="voucherId" value={values.id} />
              }
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div style={{ padding: 10 }}>
                    <Typography
                      style={{
                        color: "#1d5f98",
                        fontWeight: 600,
                        fontSize: 20,
                      }}
                      variant="h5"
                    >
                      <IconButton
                        style={{
                          paddingBottom: 0,
                          marginTop: '-15px',
                        }}
                        aria-label="Back"
                        onClick={() => handleClose()}
                        size="large"><ArrowBackIcon />
                      </IconButton>
                      {type === 1 ? 'Tuition Fee Pay Via Bank Transfer' : 'Registration Fee Pay Via Bank Transfer'}
                    </Typography>
                    <Divider />
                    <br></br>
                  </div>
                </Grid>
                <Grid style={{
                  marginTop: '-30px'
                }} item xs={12} sm={12}>
                  <ControlledExpansionPanels
                    title="Cash Payment"
                    summary={
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        style={{
                          paddingLeft: 20,
                          paddingRight: 20,
                          paddingTop: 0,
                        }}
                      >
                        <Typography
                          style={{ fontSize: 14, paddingTop: "20px" }}
                          variant="p"
                        >
                          To pay the {type === 0 && 'Registration'} Fee by cash, please follow the
                          following steps: <br />

                          <ul>
                            <li style={{ marginLeft: -15 }}>
                              Please deposit cash at any branch of Faysal
                              Bank
                            </li>

                            <li style={{ marginLeft: -15 }}>
                              Upload picture/scanned copy of the deposit slip
                            </li>
                            <li style={{ marginLeft: -15 }}>

                              Enter date of payment and transaction reference number
                            </li>
                          </ul>
                        </Typography>
                      </Grid>
                    }
                  />
                </Grid>
                <Grid style={{
                  marginTop: '-20px',
                  marginBottom: 10
                }} item xs={12} sm={12}>
                  <ControlledExpansionPanels
                    title="Inter Bank Fund Transfer (IBFT)"
                    summary={
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        style={{
                          paddingLeft: 20,
                          paddingRight: 20,
                          paddingTop: 0,
                        }}
                      >
                        <Typography
                          style={{ fontSize: 14, paddingTop: "20px" }}
                          variant="p"
                        >
                          To transfer the {type === 0 && 'Registration'} Fee online, please follow
                          the following steps: <br />

                          <ul>
                            <li style={{ marginLeft: -15 }}>
                              Log in to your bank account online or visit any
                              nearest ATM and enter the following account
                              details in the payee/beneficiary:
                            </li>

                            <li style={{ marginLeft: -15 }}>
                              Upload the picture/screenshot of the
                              transaction/email received from the bank.
                            </li>
                            <li style={{ marginLeft: -15 }}>
                              Enter date of payment and transaction reference number
                            </li>
                          </ul>
                        </Typography>
                      </Grid>
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 0,
                  }}
                >
                  <Typography
                    style={{
                      color: "#1d5f98",
                      fontWeight: 600,
                      fontSize: 16,


                    }}
                    variant="h5"
                  >
                    Bank Details:
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    marginLeft: -15,
                    paddingRight: 20,
                    marginTop: -5,
                  }}
                >
                  <Typography style={{ fontSize: 14 }} variant="p">
                    <ul>
                      <li style={{
                        listStyleType: "none", fontSize: 16,
                        padding: 2
                      }}>
                        <b>Title:</b> UCL (Pvt.) Limited
                      </li>
                      <li style={{
                        listStyleType: "none", fontSize: 16,
                        padding: 2
                      }}>
                        <b>Bank Name:</b>  Faysal Bank Limited
                      </li>
                      <li style={{
                        listStyleType: "none", fontSize: 16,
                        padding: 2
                      }}>
                        <b>Bank Address:</b> 4/5 Hassan Plaza, Cavalry
                        Ground, Lahore
                      </li>
                      <li style={{
                        listStyleType: "none", fontSize: 16,
                        padding: 2
                      }}>
                        <b>A/c No:</b> 0334000524754039
                      </li>
                      <li style={{
                        listStyleType: "none", fontSize: 16,
                        padding: 2
                      }}>
                        <b>IBN:</b> PK28FAYS0334000524754039
                      </li>
                      <li style={{
                        listStyleType: "none", fontSize: 16,
                        padding: 2
                      }}>
                        <b>Swift Code:</b> FAYSPKKA
                      </li>
                    </ul>
                  </Typography>
                </Grid>
                <Grid style={{ marginLeft: 10 }} container spacing={2}>
                  <Grid
                    item
                    xs={8}
                  >
                    <TextField
                      id="referenceNo"
                      name="referenceNo"
                      value={form.referenceNo}
                      onChange={handleChange}
                      error={!!formErrors.referenceNoError}
                      label="Reference Number"
                      disabled={values.refCheck}
                      required
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                  >
                    <FormControlLabel
                      style={{
                        marginTop: 20
                      }}
                      control={
                        <Checkbox
                          name="refCheck"
                          checked={values.refCheck}
                          onChange={e => onRefCheckChnage(e)}
                          color="primary"
                        />
                      }
                      label="Reference Number not available"
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ marginLeft: 12, marginBottom: 20 }}
                >
                  <DatePicker
                    format="dd-MMM-yyyy"
                    label="Payment Date"
                    value={form.paymentDate}
                    onChange={handleDateChange}
                    disableFuture
                    slotProps={{
                      textField: {
                        required: true,
                        fullWidth: true,
                        id: "paymentDate",
                        name: "paymentDate",
                        error: !!formErrors.paymentDate,
                        helperText: formErrors.paymentDate
                      }
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={11}
                  style={{
                    paddingLeft: 20,
                    paddingTop: 10,
                    marginTop: 0,
                  }}
                >
                  <MyDropzone form={form} onChange={event => handleFileChange(event)} disabled={values.isLoading} />
                  <div style={{
                    textAlign: 'center',
                    marginTop: 10
                  }}>
                    <span style={{
                      color: '#ff2d2d'
                    }}>{formErrors.filesError}</span>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={1}
                  style={{
                    marginTop: 10,
                  }}
                >
                  <input
                    id="submit-button"
                    type="submit"
                    style={{ display: "none" }}
                  />
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    style={{
                      width: 75,
                      height: 45,
                      textTransform: 'capitalize'
                    }}
                    onClick={handleSubmitButtonClick}
                    disabled={values.isLoading}
                  >
                    {values.isLoading ? (
                      <CircularProgress style={{ color: "white" }} size={24} />
                    ) : (
                      "Upload"
                    )}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ paddingLeft: 20, paddingTop: 10 }}
                >
                  {
                    type === 0 &&
                    <PayViaBankTransferTableComponentsForm
                      rows={values.uploadData} columns={[
                        { key: 'documentTypeLabel', label: 'Document Type', style: { width: '50%' } },
                        { key: 'uploadedOn', label: 'Upload Date', style: { width: '30%' } },

                      ]}
                      onDelete={(id) => deleteFile(id)} onDownload={(name) => downloadFile(name)}
                    />
                  }
                  {type === 1 &&
                    <PayViaBankTransferTableComponentsForm
                      rows={values.vocherData.isUploaded ? values.uploadData : []} columns={[
                        { key: 'documentTypeLabel', label: 'Document Type', style: { width: '20%' } },
                        { key: 'studentClass', label: 'Class', style: { width: '20%' } },
                        { key: 'installment', label: 'Installment', style: { width: '20%' } },
                        { key: 'createdOn', label: 'Upload Date', style: { width: '20%' } },

                      ]}
                      onDelete={(id) => deleteFile(id)} onDownload={(name) => downloadFile(name)}
                    />
                  }
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

PayThroughBankTransfer.propTypes = {
  type: PropTypes.number,
  values: PropTypes.object,
  handleSubmitButtonClick: PropTypes.func,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleFileChange: PropTypes.func,
  handleDateChange: PropTypes.func,
  onRefCheckChnage: PropTypes.func,
  handleClose: PropTypes.func,
  deleteFile: PropTypes.func,
  downloadFile: PropTypes.func
};

export default PayThroughBankTransfer;
